export default {
    props: {
        message: {
            type: String,
            required: true
        }
    }
};
